import userRoutes from './user/'; //Segmentacion de pantallas

export default [
  {
    path: 'security',
    name: 'security-menu',
    component: () => import('@/views/Security.vue'),
    children: [
      {
        path: '/security',
        name: 'security',
        component: () => import('@/views/security/Menu'),
        meta: { IsParent: true },
      },
      {
        path: '/security/Interface',
        name: 'interface',
        component: null,
      },
      {
        path: '/security/Permission',
        name: 'permission',
        component: null,
      },
      {
        path: '/security/Role',
        name: 'role',
        component: null,
      },
      {
        path: '/security/Applications',
        name: 'applications',
        component: null,
      },
      {
        path: '/security/User',
        name: 'user',
        component: null,
      },
      ...userRoutes,
    ],
  },
];
